import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {ConfigService} from '../services/utils/config.service';

@Injectable()
export class AppRoutesGuard implements CanActivate {
    constructor(private configService: ConfigService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const enabledApps = this.configService.enabledAppList;
        const targetApp = route.routeConfig.path;

        if (targetApp && enabledApps.includes(targetApp)) {
            return true;
        }

        this.router.navigateByUrl('/not-found');
        return false;
    }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/guard/AppRoutesGuard.ts